import SubcontractorOverViewSubPage from "./subcontractor-overview-sub-page";
import SubcontractorUsersSubPage    from "./subcontractor-users-sub-page";

const SubcontractorSubPage = {
    OverView : SubcontractorOverViewSubPage,
    Users    : SubcontractorUsersSubPage
};

export default SubcontractorSubPage;